<template>
  <div>
    <Desktop v-if="!mobile" />
    <Mobile v-else />
  </div>
</template>

<script>
import Desktop from "./Desktop.vue";
import Mobile from "./Mobile.vue";

export default {
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$rest("customer-area").get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    Desktop,
    Mobile,
  },
};
</script>
